export default __webpack_public_path__ + "static/media/watermelon.d92fea7d.svg";